import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './SectionContainer.module.scss';

const SectionContainer = ({
  title,
  className,
  buttonText,
  onClickButton,
  dataTestId,
  children,
}) => {
  return (
    <div className={classNames(styles.sectionContainer, className)} data-testid={dataTestId}>
      <h2>
        {buttonText && (
          <button className={styles.actionButton} onClick={onClickButton}>
            {buttonText}
          </button>
        )}
        {title}
      </h2>
      {children}
    </div>
  );
};

SectionContainer.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  buttonText: PropTypes.string,
  onClickButton: PropTypes.func,
  children: PropTypes.node.isRequired,
};

SectionContainer.defaultProps = {
  className: null,
  dataTestId: null,
  buttonText: null,
  onClickButton: () => {},
};

export default SectionContainer;
